import PresupuestoManagementPage from "../pages/PresupuestoManagementPage";
import OrdenVentaManagementPage from "../pages/OrdenVentaManagementPage";
import PresupuestoPedidoDesdeProductosPage from "../pages/PresupuestoPedidoDesdeProductosPage/PresupuestoPedidoDesdeProductosPage.vue";
import VendedorManagementPage from "../pages/VendedorManagementPage";

const routes = [
  {
    name: "PresupuestoManagementPage",
    path: "/presupuestos",
    component: PresupuestoManagementPage,
    meta: { requiresAuth: true, permission: "VENTAS_PRESUPUESTO_SHOW" },
  },
  {
    name: "OrdenVentaManagementPage",
    path: "/ordenes-venta",
    component: OrdenVentaManagementPage,
    meta: { requiresAuth: true, permission: "VENTAS_ORDEN_SHOW" },
  },
  {
    name: "PresupuestoPedidoDesdeProductosPage",
    path: "/crear-presupuesto-pedido-desde-productos",
    component: PresupuestoPedidoDesdeProductosPage,
    meta: { requiresAuth: true, permission: "VENTAS_PRESUPUESTO_SHOW" },
  },
  {
    name: "VendedorManagementPage",
    path: "/vendedores",
    component: VendedorManagementPage,
    meta: { requiresAuth: true, permission: "VENDEDOR_SHOW" },
  },
];

export default routes;
